module.exports = __webpack_public_path__ + "img/unknown.03f36dc1.svg";